import React from 'react'
import { Row, Col, CloseButton, Alert, Spinner } from '@deere/ux.uxframe-react'
import { Button, Container } from "@deere/ux.uxframe-react";
import { DOWNLOAD_ERROR, NO_INFORMATION } from '../utils/surveyLiterals';
import Has from '../components/security/has'
import { useHistory } from 'react-router'
import { LeftSearchMenu } from '../search/LeftSearchMenu'
import { useSelector } from 'react-redux';
import { ListPagination } from '../components/ListPagination';
import { RequestCampaignList } from '../components/RequestCampaignList';


export const EmployeeView = ({ showModal, hideModal, authState, abortControllerRef}) => {
    const history = useHistory();
    const campaigns = useSelector(state => state.campaign.campaigns)
    const loading = useSelector(state => state.campaign.loading)
    const pageTitle = useSelector(state => state.filter.searchTitlePage);

    function openCampaignScreen() {
        history.push({
            pathname: '/campaign',
            state: { previous: history.location.pathname }
        })
    }





    return (
        <Container fluid>
            <div style={{ margin: "10px" }}>
                <Row>
                    <Col className="col-md-16">
                        <h2>{pageTitle}</h2>
                    </Col>
                    <Col className="col-md-8 text-right">
                        <Has admin={true} redirectErrorPage={false}>
                            <Button type="submit" onClick={openCampaignScreen} >
                                Create Campaigns
                            </Button>
                        </Has>
                    </Col>
                </Row>
            </div>
            <Row>
                <div className='col-md-7'>
                    <LeftSearchMenu authState={authState} isEmployee={true} abortControllerRef={abortControllerRef} />
                </div>
                <div className='col-md-17'>
                    {campaigns && campaigns.length <= 0 ?
                        <Alert accessibilityLabel={'Info :'} variant={'info'} aria-atomic="true">
                            <h5 className="uxf-alert-title">{NO_INFORMATION}</h5>
                        </Alert>
                        : ''
                    }
                    {showModal &&
                        <Alert accessibilityLabel={'Danger :'} variant={'danger'} aria-atomic="true">
                            <h5 className="uxf-alert-title">{DOWNLOAD_ERROR}  <CloseButton onClick={hideModal} /></h5>
                        </Alert>
                    }
                    {!loading ? <ListPagination list={campaigns} authState={authState} component={RequestCampaignList} />
                        : <Spinner style={{
                            margin: 'auto',
                        }} animation="border" role="status">
                            <span className="visually-hidden"></span>
                        </Spinner>}
                </div>
            </Row>
        </Container>
    )
}